import { render, staticRenderFns } from "./SwitchWorkspace.vue?vue&type=template&id=a7ac8622&"
import script from "./SwitchWorkspace.vue?vue&type=script&lang=js&"
export * from "./SwitchWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports